<nav class="navbar top-navbar">
    <div class="container-fluid">
  
        <div class="navbar-left">
            <div class="navbar-btn">
                <a href="./home"><img src="https://sistemaperiodistas.com/crm_api/public/logo.png" alt="CRM" class="img-fluid logo"></a>
                <button type="button" class="btn-toggle-offcanvas"><i class="lnr lnr-menu fa fa-bars"></i></button>
            </div>
            <!-- <ul class="nav navbar-nav">
                <li class="dropdown">
                    <a href="javascript:void(0);" class="dropdown-toggle icon-menu" data-toggle="dropdown">
                        <i class="icon-envelope"></i>
                        <span class="notification-dot bg-green">4</span>
                    </a>
                    <ul class="dropdown-menu right_chat email vivify fadeIn">
  
                      
                        <li class="header green">You have 4 New eMail</li>
                        <li>
                            <a href="javascript:void(0);">
                                <div class="media">
                                    <div class="avtar-pic w35 bg-red"><span>FC</span></div>
                                    <div class="media-body">
                                        <span class="name">James Wert <small class="float-right text-muted">Just now</small></span>
                                        <span class="message">Update GitHub</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                      
  
                    </ul>
                </li>
               
               
                <li><a href="javascript:void(0);" class="megamenu_toggle icon-menu" title="Mega Menu">Mega</a></li>
                <li class="p_social"><a href="page-social.html" class="social icon-menu" title="News">Social</a></li>
                <li class="p_news"><a href="page-news.html" class="news icon-menu" title="News">News</a></li>
                <li class="p_blog"><a href="page-blog.html" class="blog icon-menu" title="Blog">Blog</a></li>
            </ul> -->
        </div>
        
        <div class="navbar-right">
            <div id="navbar-menu">
                <ul class="nav navbar-nav">
                    <li><a (click)="cerrar_sesion()" class="icon-menu"><i class="icon-power"></i></a></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="progress-container"><div class="progress-bar" id="myBar"></div></div>
  </nav>
  <div id="particles-js"></div>
  <div id="megamenu" class="megamenu particles_js">
  </div>
  
  <div id="left-sidebar" class="sidebar">
    <div class="navbar-brand">
        <a href="./home"><img src="https://sistemaperiodistas.com/crm_api/public/logo.png" alt="CRM Logo" class="img-fluid " style="width: 30px;"><span>CRM</span></a>
        <button type="button" class="btn-toggle-offcanvas btn btn-sm float-right" ><i class="lnr lnr-menu icon-close"></i></button>
    </div>
    <div class="sidebar-scroll">
        <div class="user-account">
            <div class="user_div">
                <img src="{{url+''+img}}" class="user-photo" alt="Image">
            </div>
            <div class="dropdown">
                <span>Bienvenido,</span><br>
                <strong>{{nombre}}</strong>
                <!-- <a href="javascript:void(0);" class="dropdown-toggle user-name" data-toggle="dropdown"><strong>Louis Pierce</strong></a>
                <ul class="dropdown-menu dropdown-menu-right account vivify flipInY">
                    <li><a href="page-profile.html"><i class="icon-user"></i>My Profile</a></li>
                    <li><a href="app-inbox.html"><i class="icon-envelope-open"></i>Messages</a></li>
                    <li><a href="javascript:void(0);"><i class="icon-settings"></i>Settings</a></li>
                    <li class="divider"></li>
                    <li><a href="page-login.html"><i class="icon-power"></i>Logout</a></li>
                </ul> -->
            </div>                
        </div>  
        <nav id="left-sidebar-nav" class="sidebar-nav">
            <ul id="main-menu" class="metismenu">
              <!-- //inicio menu -->
                <li class="header">Panel</li>
                <li  routerLinkActive="active"><a [routerLink]="['../home']"><i class="fa fa-th"></i><span>Gestor de Tareas</span></a></li>                        
                <li  routerLinkActive="active"><a [routerLink]="['../mitrabajo']"><i class="fa fa-tasks"></i><span>Mi Trabajo</span></a></li>
                <li routerLinkActive="active"><a routerLink="../calendario" ><i class="fa fa-calendar"></i><span>Calendario</span></a></li>
                <li routerLinkActive="active"><a routerLink="../perfil" ><i class="fa fa-address-card"></i><span>Perfil</span></a></li>
                <li routerLinkActive="active"><a routerLink="../agregarusuario" ><i class="fa fa-users"></i><span>Agregar Usuarios</span></a></li>
            </ul>
        </nav>     
    </div>
  </div>